"use client";

import { Button } from "@frontend/roz-uikit/studio";
import type { ComponentProps } from "react";

import { cn } from "@/lib/cn";
import { useAuth, useSdkConfig } from "@/provider";

export interface AuthButtonProps extends ComponentProps<typeof Button> {
  label?: string;
}

export const AuthButton = ({
  className,
  label = "Войти",
  ...props
}: AuthButtonProps) => {
  const { isAuthorized, login } = useAuth();
  const config = useSdkConfig();

  if (isAuthorized) {
    return null;
  }

  const isDarkHeader = config.theme === "dark";

  return (
    <Button
      className={cn(
        "sdkui:px-6 sdkui:font-medium sdkui:text-sm sdkui:shadow-none",
        className
      )}
      data-testid="Login-button"
      onClick={() => login()}
      size="lg"
      variant={isDarkHeader ? "solidSecondary" : "solidSecondaryDark"}
      {...props}
    >
      <span>{label}</span>
    </Button>
  );
};
